import { theme } from '@features/lci-report/domain/theme';
import {
  PositionProps,
  Slide,
  centerAround,
  getBoundingBoxCoords,
  getCenter,
  positionAt,
} from '@features/powerpoint';

export type CircleGraphicProps = {
  title: string;
  group: string;
  multiplierDescription: string;
  position: { x: number; y: number };
  width: number;
  baseColor: string;
  highlightColor: string;
};

export const circleGraphic = (props: CircleGraphicProps): Slide => {
  const {
    title,
    group,
    multiplierDescription,
    position,
    width,
    baseColor,
    highlightColor,
  } = props;

  const boundingBox = { ...position, h: width, w: width };

  const center = getCenter(boundingBox);

  const highlightPosition = {
    x: position.x + width * 0.03,
    y: position.y + width * 0.03,
    w: width * 0.8,
    h: width * 0.8,
  } as const satisfies PositionProps;

  const highlightTextPosition = centerAround(getCenter(highlightPosition), {
    h: 0.5,
    w: width * 0.66,
  });

  const titlePosition = centerAround(center, { h: 0.71, w: width * 0.8 });

  const multiplierPosition = centerAround(center, {
    w: width / 2,
    h: 0.61,
  });

  const arrowPosition = positionAt(
    getBoundingBoxCoords(boundingBox, 'bottom-right'),
    { h: 0.5, w: 0.5 },
    'bottom-right'
  );

  return {
    texts: [
      {
        text: title,
        options: {
          ...titlePosition,
          y: position.y + width + 0.1,
          bold: true,
          color: theme.colors.white,
          align: 'center',
        },
      },
      {
        text: group,
        options: {
          ...highlightTextPosition,
          bold: true,
          align: 'center',
          fontSize: 12,
        },
      },
      {
        text: multiplierDescription,
        options: {
          ...multiplierPosition,
          y: position.y + width - 0.75,
          bold: true,
          fontSize: 10,
          align: 'center',
        },
      },
    ],
    shapes: [
      {
        shapeName: 'ellipse',
        options: {
          x: position.x,
          y: position.y,
          w: width,
          h: width,
          fill: { color: baseColor },
        },
      },
      {
        shapeName: 'ellipse',
        options: {
          ...highlightPosition,
          fill: { color: highlightColor },
        },
      },
      {
        shapeName: 'line',
        options: {
          ...arrowPosition,
          x: arrowPosition.x - 0.5,
          y: arrowPosition.y - 0.5,
          line: {
            color: theme.colors.black,
            width: 0.75,
            dashType: 'dash',
            endArrowType: 'triangle',
          },
        },
      },
    ],
  };
};
